// Input: Date object
// Output: "Monday, Jan 1, 2024"
export function getFormattedDate(date = new Date()) {
  return date.toLocaleDateString('en-US', {
    weekday: 'long',
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}

// Input: Date object
// Output: "2024-01-01"
export const formatDateToYearMonthDayString = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Input: "YYY-mm-dd"
// Output: "Nov 11, 2025"
export const formatYMDToLongDateString = (dateString: Date) => {
  const fmt = new Intl.DateTimeFormat('en-US', {
    'year': 'numeric',
    'month': 'short',
    'day': 'numeric',
  });

  const date = new Date(dateString + 'T00:00');

  return fmt.format(date);
};

// Input: Date object
// Output: "Dec 10, 6:30 pm"
export const getConciseDateTime = (date = new Date()) => {
  return date.toLocaleString('en-US', {
    day: 'numeric',
    month: 'short',
    hour: 'numeric',
    minute: 'numeric',
    hour12: true,
  });
};

// Input (different months): ("2025-12-28", "2026-01-03")
// Output: "Dec 28-Jan 3"
// Input (same month): ("2026-01-04", "2026-01-10")
// Output: "Jan 4-10"
export const getWeeksText = (start?: Date | null, end?: Date | null) => {
  if (!start || !end) {
    return '';
  }

  const startDate = new Date(start + 'T00:00');
  const endDate = new Date(end + 'T00:00');

  const isSameMonth = startDate.getMonth() === endDate.getMonth();
  const startDateStr = startDate.toLocaleDateString('en-US', { day: 'numeric', month: 'short' });
  const endDateStr = endDate.toLocaleDateString('en-US', { day: 'numeric', month: !isSameMonth ? 'short' : undefined });

  return `(${startDateStr}-${endDateStr})`;
};
